import React from 'react'
import BasicPage from './BasicPage'

export default function NotFoundPage({title}) {
  return <BasicPage title='Page not found' />
}
